import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

interface StatusChoice {
    id: string;
    name: string;
    values: string[];
}

interface StatusFilterProps {
    source?: string;
    label?: string;
    alwaysOn?: boolean;
    className?: string;
}

const StatusFilter = (props: StatusFilterProps = {}) => {
    const t = useTranslate();
    const { source = 'productCurrentStatusName', label, alwaysOn, className } = props;

    // Grouped status options as specified by the user
    const statusChoices: StatusChoice[] = [
        {
            id: 'PRÊTE À LIVRER',
            name: 'Prête à livrer',
            values: ['PRÊTE À LIVRER, VALIDÉ QUALITÉ', 'PRÊTE À LIVRER', 'PRÊTE À LIVRET, VALIDÉ QUALITÉ'],
        },
        {
            id: 'PRÊTE À POSER',
            name: 'Prête à poser',
            values: ['Prête à poser'],
        },
        {
            id: 'BLOQUÉ QUALITÉ',
            name: 'Bloqué qualité',
            values: ['Bloqué qualité'],
        },
        {
            id: 'TRAVAUX DE POSE EFFECTUÉ',
            name: 'Travaux de pose effectué',
            values: ['TRAVAUX DE POSE EFFECTUÉS', 'TRAVAUX DE POSE EFFECTUÉS AVEC RESERVES'],
        },
        {
            id: 'MISE EN SERVICE',
            name: 'Mise en service',
            values: ['FIN DE MISE EN SERVICE', 'MISE EN SERVICE'],
        },
        {
            id: 'REBUT',
            name: 'Rebut',
            values: ['Rebut'],
        },
    ];

    const {
        input: { onChange, value, ...inputProps },
        meta: { error, touched },
    } = useInput({
        source: source,
        alwaysOn: alwaysOn,
        parse: (value: any) => {
            // When a grouped option is selected, return the array of values
            const selectedOption = statusChoices.find((choice) => choice.id === value);
            return selectedOption ? selectedOption.values : value;
        },
        format: (value: any) => {
            // When the value is an array, find the corresponding grouped option
            if (Array.isArray(value)) {
                const selectedOption = statusChoices.find(
                    (choice) => JSON.stringify(choice.values.sort()) === JSON.stringify(value.sort()),
                );
                return selectedOption ? selectedOption.id : value;
            }
            return value;
        },
    });

    const handleChange = (event: any) => {
        onChange(event.target.value);
    };

    return (
        <FormControl variant='standard' size='small' fullWidth className={className}>
            <InputLabel shrink>{label || t('app.ancs.nodeStateName')}</InputLabel>
            <Select
                {...inputProps}
                value={value || ''}
                onChange={handleChange}
                error={touched && !!error}
            >
                {statusChoices.map((choice) => (
                    <MenuItem key={choice.id} value={choice.id}>
                        {choice.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default StatusFilter;
